import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'

import type { GetListsLazyQsParams, ListLazy, PagedListOf } from 'Types/beListApi'

const endpoints = ((baseURL: string) => {
  return {
    GetListsLazy: `${baseURL}/api/listslazy`,
  }
})(process.env.BELIST_URL as unknown as string)

export const beListApiGetListsLazy = async (
  params: GetListsLazyQsParams,
): Promise<PagedListOf<ListLazy>> => {
  return apiWrapper.get(endpoints.GetListsLazy, { params }).then(extractApiData)
}
